import Grid from '@mui/material/Grid';
import { FC, memo } from 'react';

import { SOCIAL_MEDIA } from '../../assets/data/social-media';
import { EXTERNAL_ROUTE_PROPS } from '../route/utils';
import { SocialIconButton } from './styled';

const FooterSocial: FC = () => (
  <Grid container spacing='0.5rem' sx={{ marginTop: '2.5rem', textAlign: 'center' }}>
    {Object.values(SOCIAL_MEDIA).map(({ icon, url }) => (
      <Grid key={url} size={{ sm: 2.4, xs: 6 }}>
        <SocialIconButton
          className='menu-button'
          href={url}
          rel={EXTERNAL_ROUTE_PROPS.rel}
          target={EXTERNAL_ROUTE_PROPS.target}
        >
          {icon}
        </SocialIconButton>
      </Grid>
    ))}
  </Grid>
);

export default memo(FooterSocial);
